// source: proto/mdds/v1/mdds.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.proto.mdds.v1.BoardEvent', null, global);
goog.exportSymbol('proto.proto.mdds.v1.BoardEventID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.BoardID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MarketID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MarketIndex', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MarketIndexClass', null, global);
goog.exportSymbol('proto.proto.mdds.v1.OrderMini', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ProductGrpID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.PutOrCall', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SIExerciseStyle', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SISecurityStatus', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SectorTypeCode', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SecurityGroupID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SettleMethod', null, global);
goog.exportSymbol('proto.proto.mdds.v1.StockInfo', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolAdminStatusCode', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolBoardEvent', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolTradingMethodStatusCode', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolTradingSanctionStatusCode', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Tick', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Tick.Side', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TopPrice', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TradingSessionID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TscProdGrpId', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Wrapper', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Wrapper.KindCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.Wrapper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.proto.mdds.v1.Wrapper.oneofGroups_);
};
goog.inherits(proto.proto.mdds.v1.Wrapper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.Wrapper.displayName = 'proto.proto.mdds.v1.Wrapper';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.StockInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.StockInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.StockInfo.displayName = 'proto.proto.mdds.v1.StockInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.BoardEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.BoardEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.BoardEvent.displayName = 'proto.proto.mdds.v1.BoardEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.SymbolBoardEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.SymbolBoardEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.SymbolBoardEvent.displayName = 'proto.proto.mdds.v1.SymbolBoardEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.MarketIndex = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.MarketIndex, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.MarketIndex.displayName = 'proto.proto.mdds.v1.MarketIndex';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.Tick = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.Tick, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.Tick.displayName = 'proto.proto.mdds.v1.Tick';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.TopPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.mdds.v1.TopPrice.repeatedFields_, null);
};
goog.inherits(proto.proto.mdds.v1.TopPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.TopPrice.displayName = 'proto.proto.mdds.v1.TopPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.OrderMini = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.OrderMini, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.OrderMini.displayName = 'proto.proto.mdds.v1.OrderMini';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.proto.mdds.v1.Wrapper.oneofGroups_ = [[41,42,43,44,45,46]];

/**
 * @enum {number}
 */
proto.proto.mdds.v1.Wrapper.KindCase = {
  KIND_NOT_SET: 0,
  STOCK_INFO: 41,
  MARKET_INDEX: 42,
  BOARD_EVENT: 43,
  SYMBOL_BOARD_EVENT: 44,
  TICK: 45,
  TOP_PRICE: 46
};

/**
 * @return {proto.proto.mdds.v1.Wrapper.KindCase}
 */
proto.proto.mdds.v1.Wrapper.prototype.getKindCase = function() {
  return /** @type {proto.proto.mdds.v1.Wrapper.KindCase} */(jspb.Message.computeOneofCase(this, proto.proto.mdds.v1.Wrapper.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.Wrapper.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.Wrapper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.Wrapper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Wrapper.toObject = function(includeInstance, msg) {
  var f, obj = {
    stockInfo: (f = msg.getStockInfo()) && proto.proto.mdds.v1.StockInfo.toObject(includeInstance, f),
    marketIndex: (f = msg.getMarketIndex()) && proto.proto.mdds.v1.MarketIndex.toObject(includeInstance, f),
    boardEvent: (f = msg.getBoardEvent()) && proto.proto.mdds.v1.BoardEvent.toObject(includeInstance, f),
    symbolBoardEvent: (f = msg.getSymbolBoardEvent()) && proto.proto.mdds.v1.SymbolBoardEvent.toObject(includeInstance, f),
    tick: (f = msg.getTick()) && proto.proto.mdds.v1.Tick.toObject(includeInstance, f),
    topPrice: (f = msg.getTopPrice()) && proto.proto.mdds.v1.TopPrice.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.Wrapper}
 */
proto.proto.mdds.v1.Wrapper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.Wrapper;
  return proto.proto.mdds.v1.Wrapper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.Wrapper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.Wrapper}
 */
proto.proto.mdds.v1.Wrapper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 41:
      var value = new proto.proto.mdds.v1.StockInfo;
      reader.readMessage(value,proto.proto.mdds.v1.StockInfo.deserializeBinaryFromReader);
      msg.setStockInfo(value);
      break;
    case 42:
      var value = new proto.proto.mdds.v1.MarketIndex;
      reader.readMessage(value,proto.proto.mdds.v1.MarketIndex.deserializeBinaryFromReader);
      msg.setMarketIndex(value);
      break;
    case 43:
      var value = new proto.proto.mdds.v1.BoardEvent;
      reader.readMessage(value,proto.proto.mdds.v1.BoardEvent.deserializeBinaryFromReader);
      msg.setBoardEvent(value);
      break;
    case 44:
      var value = new proto.proto.mdds.v1.SymbolBoardEvent;
      reader.readMessage(value,proto.proto.mdds.v1.SymbolBoardEvent.deserializeBinaryFromReader);
      msg.setSymbolBoardEvent(value);
      break;
    case 45:
      var value = new proto.proto.mdds.v1.Tick;
      reader.readMessage(value,proto.proto.mdds.v1.Tick.deserializeBinaryFromReader);
      msg.setTick(value);
      break;
    case 46:
      var value = new proto.proto.mdds.v1.TopPrice;
      reader.readMessage(value,proto.proto.mdds.v1.TopPrice.deserializeBinaryFromReader);
      msg.setTopPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.Wrapper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.Wrapper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.Wrapper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Wrapper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStockInfo();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      proto.proto.mdds.v1.StockInfo.serializeBinaryToWriter
    );
  }
  f = message.getMarketIndex();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      proto.proto.mdds.v1.MarketIndex.serializeBinaryToWriter
    );
  }
  f = message.getBoardEvent();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      proto.proto.mdds.v1.BoardEvent.serializeBinaryToWriter
    );
  }
  f = message.getSymbolBoardEvent();
  if (f != null) {
    writer.writeMessage(
      44,
      f,
      proto.proto.mdds.v1.SymbolBoardEvent.serializeBinaryToWriter
    );
  }
  f = message.getTick();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      proto.proto.mdds.v1.Tick.serializeBinaryToWriter
    );
  }
  f = message.getTopPrice();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      proto.proto.mdds.v1.TopPrice.serializeBinaryToWriter
    );
  }
};


/**
 * optional StockInfo stock_info = 41;
 * @return {?proto.proto.mdds.v1.StockInfo}
 */
proto.proto.mdds.v1.Wrapper.prototype.getStockInfo = function() {
  return /** @type{?proto.proto.mdds.v1.StockInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.StockInfo, 41));
};


/**
 * @param {?proto.proto.mdds.v1.StockInfo|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setStockInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 41, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearStockInfo = function() {
  return this.setStockInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasStockInfo = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional MarketIndex market_index = 42;
 * @return {?proto.proto.mdds.v1.MarketIndex}
 */
proto.proto.mdds.v1.Wrapper.prototype.getMarketIndex = function() {
  return /** @type{?proto.proto.mdds.v1.MarketIndex} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.MarketIndex, 42));
};


/**
 * @param {?proto.proto.mdds.v1.MarketIndex|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setMarketIndex = function(value) {
  return jspb.Message.setOneofWrapperField(this, 42, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearMarketIndex = function() {
  return this.setMarketIndex(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasMarketIndex = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional BoardEvent board_event = 43;
 * @return {?proto.proto.mdds.v1.BoardEvent}
 */
proto.proto.mdds.v1.Wrapper.prototype.getBoardEvent = function() {
  return /** @type{?proto.proto.mdds.v1.BoardEvent} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.BoardEvent, 43));
};


/**
 * @param {?proto.proto.mdds.v1.BoardEvent|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setBoardEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 43, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearBoardEvent = function() {
  return this.setBoardEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasBoardEvent = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional SymbolBoardEvent symbol_board_event = 44;
 * @return {?proto.proto.mdds.v1.SymbolBoardEvent}
 */
proto.proto.mdds.v1.Wrapper.prototype.getSymbolBoardEvent = function() {
  return /** @type{?proto.proto.mdds.v1.SymbolBoardEvent} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.SymbolBoardEvent, 44));
};


/**
 * @param {?proto.proto.mdds.v1.SymbolBoardEvent|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setSymbolBoardEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 44, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearSymbolBoardEvent = function() {
  return this.setSymbolBoardEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasSymbolBoardEvent = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional Tick tick = 45;
 * @return {?proto.proto.mdds.v1.Tick}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTick = function() {
  return /** @type{?proto.proto.mdds.v1.Tick} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.Tick, 45));
};


/**
 * @param {?proto.proto.mdds.v1.Tick|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTick = function(value) {
  return jspb.Message.setOneofWrapperField(this, 45, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTick = function() {
  return this.setTick(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTick = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional TopPrice top_price = 46;
 * @return {?proto.proto.mdds.v1.TopPrice}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTopPrice = function() {
  return /** @type{?proto.proto.mdds.v1.TopPrice} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.TopPrice, 46));
};


/**
 * @param {?proto.proto.mdds.v1.TopPrice|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTopPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 46, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTopPrice = function() {
  return this.setTopPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTopPrice = function() {
  return jspb.Message.getField(this, 46) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.StockInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.StockInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.StockInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.StockInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isin: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tradingTime: (f = msg.getTradingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    productId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    productGrpId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    securityGroupId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    referencePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    highLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    lowLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    highestPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    lowestPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    openPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    closePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    averagePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    buyForeignQuantity: jspb.Message.getFieldWithDefault(msg, 17, 0),
    sellForeignQuantity: jspb.Message.getFieldWithDefault(msg, 18, 0),
    securityStatus: jspb.Message.getFieldWithDefault(msg, 19, 0),
    foreignerOrderLimitQuantity: jspb.Message.getFieldWithDefault(msg, 20, 0),
    expectedTradePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
    expectedTradeQuantity: jspb.Message.getFieldWithDefault(msg, 22, 0),
    openInterestQuantity: jspb.Message.getFieldWithDefault(msg, 23, 0),
    totalVolumeTraded: jspb.Message.getFieldWithDefault(msg, 24, 0),
    grossTradeAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
    sellTotalOrderQuantity: jspb.Message.getFieldWithDefault(msg, 26, 0),
    buyTotalOrderQuantity: jspb.Message.getFieldWithDefault(msg, 27, 0),
    matchPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
    matchQuantity: jspb.Message.getFieldWithDefault(msg, 29, 0),
    matchValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 30, 0.0),
    changedValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 31, 0.0),
    changedRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 32, 0.0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 33, 0),
    bidQuantity: jspb.Message.getFieldWithDefault(msg, 34, 0),
    offerQuantity: jspb.Message.getFieldWithDefault(msg, 35, 0),
    lastTradingDate: (f = msg.getLastTradingDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    symbolType: jspb.Message.getFieldWithDefault(msg, 37, ""),
    putOrCall: jspb.Message.getFieldWithDefault(msg, 38, 0),
    exerciseStyle: jspb.Message.getFieldWithDefault(msg, 39, 0),
    maturityDate: (f = msg.getMaturityDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    issuer: jspb.Message.getFieldWithDefault(msg, 41, ""),
    issueDate: (f = msg.getIssueDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contractMultiplier: jspb.Message.getFloatingPointFieldWithDefault(msg, 43, 0.0),
    strikePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 44, 0.0),
    listedShares: jspb.Message.getFieldWithDefault(msg, 45, 0),
    settlementMethod: jspb.Message.getFieldWithDefault(msg, 46, 0),
    firstTradingDate: (f = msg.getFirstTradingDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    finalSettlementDate: (f = msg.getFinalSettlementDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    listingDate: (f = msg.getListingDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    couponRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 50, 0.0),
    yield: jspb.Message.getFloatingPointFieldWithDefault(msg, 51, 0.0),
    symbolAdminStatusCode: jspb.Message.getFieldWithDefault(msg, 52, 0),
    symbolTradingMethodStatusCode: jspb.Message.getFieldWithDefault(msg, 53, 0),
    symbolTradingSanctionStatusCode: jspb.Message.getFieldWithDefault(msg, 54, 0),
    boardIdOriginal: jspb.Message.getFieldWithDefault(msg, 55, 0),
    sectorTypeCode: jspb.Message.getFieldWithDefault(msg, 56, 0),
    redumptionDate: (f = msg.getRedumptionDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    buyForeignValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 58, 0.0),
    sellForeignValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 59, 0.0),
    foreignerBuyPossibleQuantity: jspb.Message.getFieldWithDefault(msg, 60, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.StockInfo}
 */
proto.proto.mdds.v1.StockInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.StockInfo;
  return proto.proto.mdds.v1.StockInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.StockInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.StockInfo}
 */
proto.proto.mdds.v1.StockInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradingTime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 7:
      var value = /** @type {!proto.proto.mdds.v1.ProductGrpID} */ (reader.readEnum());
      msg.setProductGrpId(value);
      break;
    case 8:
      var value = /** @type {!proto.proto.mdds.v1.SecurityGroupID} */ (reader.readEnum());
      msg.setSecurityGroupId(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReferencePrice(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighLimitPrice(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowLimitPrice(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighestPrice(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowestPrice(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPrice(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClosePrice(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAveragePrice(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyForeignQuantity(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellForeignQuantity(value);
      break;
    case 19:
      var value = /** @type {!proto.proto.mdds.v1.SISecurityStatus} */ (reader.readEnum());
      msg.setSecurityStatus(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setForeignerOrderLimitQuantity(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectedTradePrice(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExpectedTradeQuantity(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOpenInterestQuantity(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalVolumeTraded(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossTradeAmount(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellTotalOrderQuantity(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyTotalOrderQuantity(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchPrice(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMatchQuantity(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchValue(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChangedValue(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChangedRatio(value);
      break;
    case 33:
      var value = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBidQuantity(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOfferQuantity(value);
      break;
    case 36:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastTradingDate(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolType(value);
      break;
    case 38:
      var value = /** @type {!proto.proto.mdds.v1.PutOrCall} */ (reader.readEnum());
      msg.setPutOrCall(value);
      break;
    case 39:
      var value = /** @type {!proto.proto.mdds.v1.SIExerciseStyle} */ (reader.readEnum());
      msg.setExerciseStyle(value);
      break;
    case 40:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setMaturityDate(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssuer(value);
      break;
    case 42:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setIssueDate(value);
      break;
    case 43:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContractMultiplier(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStrikePrice(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setListedShares(value);
      break;
    case 46:
      var value = /** @type {!proto.proto.mdds.v1.SettleMethod} */ (reader.readEnum());
      msg.setSettlementMethod(value);
      break;
    case 47:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFirstTradingDate(value);
      break;
    case 48:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinalSettlementDate(value);
      break;
    case 49:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setListingDate(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCouponRate(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYield(value);
      break;
    case 52:
      var value = /** @type {!proto.proto.mdds.v1.SymbolAdminStatusCode} */ (reader.readEnum());
      msg.setSymbolAdminStatusCode(value);
      break;
    case 53:
      var value = /** @type {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode} */ (reader.readEnum());
      msg.setSymbolTradingMethodStatusCode(value);
      break;
    case 54:
      var value = /** @type {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode} */ (reader.readEnum());
      msg.setSymbolTradingSanctionStatusCode(value);
      break;
    case 55:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardIdOriginal(value);
      break;
    case 56:
      var value = /** @type {!proto.proto.mdds.v1.SectorTypeCode} */ (reader.readEnum());
      msg.setSectorTypeCode(value);
      break;
    case 57:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRedumptionDate(value);
      break;
    case 58:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBuyForeignValue(value);
      break;
    case 59:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSellForeignValue(value);
      break;
    case 60:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setForeignerBuyPossibleQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.StockInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.StockInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.StockInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.StockInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIsin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTradingTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProductGrpId();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSecurityGroupId();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getReferencePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getHighLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getLowLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getHighestPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getLowestPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getOpenPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getClosePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getAveragePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getBuyForeignQuantity();
  if (f !== 0) {
    writer.writeUint64(
      17,
      f
    );
  }
  f = message.getSellForeignQuantity();
  if (f !== 0) {
    writer.writeUint64(
      18,
      f
    );
  }
  f = message.getSecurityStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getForeignerOrderLimitQuantity();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getExpectedTradePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getExpectedTradeQuantity();
  if (f !== 0) {
    writer.writeUint64(
      22,
      f
    );
  }
  f = message.getOpenInterestQuantity();
  if (f !== 0) {
    writer.writeUint64(
      23,
      f
    );
  }
  f = message.getTotalVolumeTraded();
  if (f !== 0) {
    writer.writeUint64(
      24,
      f
    );
  }
  f = message.getGrossTradeAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeUint64(
      26,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeUint64(
      27,
      f
    );
  }
  f = message.getMatchPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getMatchQuantity();
  if (f !== 0) {
    writer.writeUint64(
      29,
      f
    );
  }
  f = message.getMatchValue();
  if (f !== 0.0) {
    writer.writeDouble(
      30,
      f
    );
  }
  f = message.getChangedValue();
  if (f !== 0.0) {
    writer.writeDouble(
      31,
      f
    );
  }
  f = message.getChangedRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      32,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f !== 0.0) {
    writer.writeEnum(
      33,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeUint64(
      34,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeUint64(
      35,
      f
    );
  }
  f = message.getLastTradingDate();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSymbolType();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.PutOrCall} */ (jspb.Message.getField(message, 38));
  if (f != null) {
    writer.writeEnum(
      38,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SIExerciseStyle} */ (jspb.Message.getField(message, 39));
  if (f != null) {
    writer.writeEnum(
      39,
      f
    );
  }
  f = message.getMaturityDate();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 41));
  if (f != null) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getIssueDate();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContractMultiplier();
  if (f !== 0.0) {
    writer.writeDouble(
      43,
      f
    );
  }
  f = message.getStrikePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      44,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 45));
  if (f != null) {
    writer.writeUint64(
      45,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SettleMethod} */ (jspb.Message.getField(message, 46));
  if (f != null) {
    writer.writeEnum(
      46,
      f
    );
  }
  f = message.getFirstTradingDate();
  if (f != null) {
    writer.writeMessage(
      47,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinalSettlementDate();
  if (f != null) {
    writer.writeMessage(
      48,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getListingDate();
  if (f != null) {
    writer.writeMessage(
      49,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 50));
  if (f != null) {
    writer.writeDouble(
      50,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 51));
  if (f != null) {
    writer.writeDouble(
      51,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SymbolAdminStatusCode} */ (jspb.Message.getField(message, 52));
  if (f != null) {
    writer.writeEnum(
      52,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode} */ (jspb.Message.getField(message, 53));
  if (f != null) {
    writer.writeEnum(
      53,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode} */ (jspb.Message.getField(message, 54));
  if (f != null) {
    writer.writeEnum(
      54,
      f
    );
  }
  f = message.getBoardIdOriginal();
  if (f !== 0.0) {
    writer.writeEnum(
      55,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SectorTypeCode} */ (jspb.Message.getField(message, 56));
  if (f != null) {
    writer.writeEnum(
      56,
      f
    );
  }
  f = message.getRedumptionDate();
  if (f != null) {
    writer.writeMessage(
      57,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBuyForeignValue();
  if (f !== 0.0) {
    writer.writeDouble(
      58,
      f
    );
  }
  f = message.getSellForeignValue();
  if (f !== 0.0) {
    writer.writeDouble(
      59,
      f
    );
  }
  f = message.getForeignerBuyPossibleQuantity();
  if (f !== 0) {
    writer.writeUint64(
      60,
      f
    );
  }
};


/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BoardID board_id = 2;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBoardId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string isin = 3;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getIsin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setIsin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp trading_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getTradingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setTradingTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearTradingTime = function() {
  return this.setTradingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasTradingTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string product_id = 6;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ProductGrpID product_grp_id = 7;
 * @return {!proto.proto.mdds.v1.ProductGrpID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getProductGrpId = function() {
  return /** @type {!proto.proto.mdds.v1.ProductGrpID} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.proto.mdds.v1.ProductGrpID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setProductGrpId = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional SecurityGroupID security_group_id = 8;
 * @return {!proto.proto.mdds.v1.SecurityGroupID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSecurityGroupId = function() {
  return /** @type {!proto.proto.mdds.v1.SecurityGroupID} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SecurityGroupID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSecurityGroupId = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional double reference_price = 9;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getReferencePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setReferencePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double high_limit_price = 10;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getHighLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setHighLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double low_limit_price = 11;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getLowLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setLowLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double highest_price = 12;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getHighestPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setHighestPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double lowest_price = 13;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getLowestPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setLowestPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double open_price = 14;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getOpenPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setOpenPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double close_price = 15;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getClosePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setClosePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double average_price = 16;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getAveragePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setAveragePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional uint64 buy_foreign_quantity = 17;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBuyForeignQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBuyForeignQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional uint64 sell_foreign_quantity = 18;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSellForeignQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSellForeignQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional SISecurityStatus security_status = 19;
 * @return {!proto.proto.mdds.v1.SISecurityStatus}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSecurityStatus = function() {
  return /** @type {!proto.proto.mdds.v1.SISecurityStatus} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SISecurityStatus} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSecurityStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional int64 foreigner_order_limit_quantity = 20;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getForeignerOrderLimitQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setForeignerOrderLimitQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional double expected_trade_price = 21;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getExpectedTradePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setExpectedTradePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional uint64 expected_trade_quantity = 22;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getExpectedTradeQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setExpectedTradeQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional uint64 open_interest_quantity = 23;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getOpenInterestQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setOpenInterestQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional uint64 total_volume_traded = 24;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getTotalVolumeTraded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional double gross_trade_amount = 25;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getGrossTradeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setGrossTradeAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional uint64 sell_total_order_quantity = 26;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSellTotalOrderQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSellTotalOrderQuantity = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSellTotalOrderQuantity = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSellTotalOrderQuantity = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional uint64 buy_total_order_quantity = 27;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBuyTotalOrderQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBuyTotalOrderQuantity = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearBuyTotalOrderQuantity = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasBuyTotalOrderQuantity = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional double match_price = 28;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMatchPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setMatchPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional uint64 match_quantity = 29;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMatchQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setMatchQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional double match_value = 30;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMatchValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setMatchValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 30, value);
};


/**
 * optional double changed_value = 31;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getChangedValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setChangedValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 31, value);
};


/**
 * optional double changed_ratio = 32;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getChangedRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setChangedRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 32, value);
};


/**
 * optional TradingSessionID trading_session_id = 33;
 * @return {!proto.proto.mdds.v1.TradingSessionID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getTradingSessionId = function() {
  return /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TradingSessionID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3EnumField(this, 33, value);
};


/**
 * optional uint64 bid_quantity = 34;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBidQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBidQuantity = function(value) {
  return jspb.Message.setField(this, 34, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearBidQuantity = function() {
  return jspb.Message.setField(this, 34, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasBidQuantity = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional uint64 offer_quantity = 35;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getOfferQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setOfferQuantity = function(value) {
  return jspb.Message.setField(this, 35, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearOfferQuantity = function() {
  return jspb.Message.setField(this, 35, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasOfferQuantity = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.Timestamp last_trading_date = 36;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getLastTradingDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 36));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setLastTradingDate = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearLastTradingDate = function() {
  return this.setLastTradingDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasLastTradingDate = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional string symbol_type = 37;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbolType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbolType = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional PutOrCall put_or_call = 38;
 * @return {!proto.proto.mdds.v1.PutOrCall}
 */
proto.proto.mdds.v1.StockInfo.prototype.getPutOrCall = function() {
  return /** @type {!proto.proto.mdds.v1.PutOrCall} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {!proto.proto.mdds.v1.PutOrCall} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setPutOrCall = function(value) {
  return jspb.Message.setField(this, 38, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearPutOrCall = function() {
  return jspb.Message.setField(this, 38, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasPutOrCall = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional SIExerciseStyle exercise_style = 39;
 * @return {!proto.proto.mdds.v1.SIExerciseStyle}
 */
proto.proto.mdds.v1.StockInfo.prototype.getExerciseStyle = function() {
  return /** @type {!proto.proto.mdds.v1.SIExerciseStyle} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SIExerciseStyle} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setExerciseStyle = function(value) {
  return jspb.Message.setField(this, 39, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearExerciseStyle = function() {
  return jspb.Message.setField(this, 39, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasExerciseStyle = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional google.protobuf.Timestamp maturity_date = 40;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMaturityDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 40));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setMaturityDate = function(value) {
  return jspb.Message.setWrapperField(this, 40, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearMaturityDate = function() {
  return this.setMaturityDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasMaturityDate = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional string issuer = 41;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setIssuer = function(value) {
  return jspb.Message.setField(this, 41, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearIssuer = function() {
  return jspb.Message.setField(this, 41, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasIssuer = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional google.protobuf.Timestamp issue_date = 42;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getIssueDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 42));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setIssueDate = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearIssueDate = function() {
  return this.setIssueDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasIssueDate = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional double contract_multiplier = 43;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getContractMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 43, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setContractMultiplier = function(value) {
  return jspb.Message.setProto3FloatField(this, 43, value);
};


/**
 * optional double strike_price = 44;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getStrikePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 44, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setStrikePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 44, value);
};


/**
 * optional uint64 listed_shares = 45;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getListedShares = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setListedShares = function(value) {
  return jspb.Message.setField(this, 45, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearListedShares = function() {
  return jspb.Message.setField(this, 45, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasListedShares = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional SettleMethod settlement_method = 46;
 * @return {!proto.proto.mdds.v1.SettleMethod}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSettlementMethod = function() {
  return /** @type {!proto.proto.mdds.v1.SettleMethod} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SettleMethod} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSettlementMethod = function(value) {
  return jspb.Message.setField(this, 46, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSettlementMethod = function() {
  return jspb.Message.setField(this, 46, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSettlementMethod = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional google.protobuf.Timestamp first_trading_date = 47;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getFirstTradingDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 47));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setFirstTradingDate = function(value) {
  return jspb.Message.setWrapperField(this, 47, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearFirstTradingDate = function() {
  return this.setFirstTradingDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasFirstTradingDate = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional google.protobuf.Timestamp final_settlement_date = 48;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getFinalSettlementDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 48));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setFinalSettlementDate = function(value) {
  return jspb.Message.setWrapperField(this, 48, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearFinalSettlementDate = function() {
  return this.setFinalSettlementDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasFinalSettlementDate = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional google.protobuf.Timestamp listing_date = 49;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getListingDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 49));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setListingDate = function(value) {
  return jspb.Message.setWrapperField(this, 49, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearListingDate = function() {
  return this.setListingDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasListingDate = function() {
  return jspb.Message.getField(this, 49) != null;
};


/**
 * optional double coupon_rate = 50;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getCouponRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 50, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setCouponRate = function(value) {
  return jspb.Message.setField(this, 50, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearCouponRate = function() {
  return jspb.Message.setField(this, 50, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasCouponRate = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional double yield = 51;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 51, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setYield = function(value) {
  return jspb.Message.setField(this, 51, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearYield = function() {
  return jspb.Message.setField(this, 51, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasYield = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional SymbolAdminStatusCode symbol_admin_status_code = 52;
 * @return {!proto.proto.mdds.v1.SymbolAdminStatusCode}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbolAdminStatusCode = function() {
  return /** @type {!proto.proto.mdds.v1.SymbolAdminStatusCode} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SymbolAdminStatusCode} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbolAdminStatusCode = function(value) {
  return jspb.Message.setField(this, 52, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSymbolAdminStatusCode = function() {
  return jspb.Message.setField(this, 52, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSymbolAdminStatusCode = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional SymbolTradingMethodStatusCode symbol_trading_method_status_code = 53;
 * @return {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbolTradingMethodStatusCode = function() {
  return /** @type {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbolTradingMethodStatusCode = function(value) {
  return jspb.Message.setField(this, 53, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSymbolTradingMethodStatusCode = function() {
  return jspb.Message.setField(this, 53, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSymbolTradingMethodStatusCode = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * optional SymbolTradingSanctionStatusCode symbol_trading_sanction_status_code = 54;
 * @return {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbolTradingSanctionStatusCode = function() {
  return /** @type {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode} */ (jspb.Message.getFieldWithDefault(this, 54, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbolTradingSanctionStatusCode = function(value) {
  return jspb.Message.setField(this, 54, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSymbolTradingSanctionStatusCode = function() {
  return jspb.Message.setField(this, 54, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSymbolTradingSanctionStatusCode = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional BoardID board_id_original = 55;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBoardIdOriginal = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBoardIdOriginal = function(value) {
  return jspb.Message.setProto3EnumField(this, 55, value);
};


/**
 * optional SectorTypeCode sector_type_code = 56;
 * @return {!proto.proto.mdds.v1.SectorTypeCode}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSectorTypeCode = function() {
  return /** @type {!proto.proto.mdds.v1.SectorTypeCode} */ (jspb.Message.getFieldWithDefault(this, 56, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SectorTypeCode} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSectorTypeCode = function(value) {
  return jspb.Message.setField(this, 56, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSectorTypeCode = function() {
  return jspb.Message.setField(this, 56, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSectorTypeCode = function() {
  return jspb.Message.getField(this, 56) != null;
};


/**
 * optional google.protobuf.Timestamp redumption_date = 57;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getRedumptionDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 57));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setRedumptionDate = function(value) {
  return jspb.Message.setWrapperField(this, 57, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearRedumptionDate = function() {
  return this.setRedumptionDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasRedumptionDate = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional double buy_foreign_value = 58;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBuyForeignValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 58, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBuyForeignValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 58, value);
};


/**
 * optional double sell_foreign_value = 59;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSellForeignValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 59, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSellForeignValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 59, value);
};


/**
 * optional uint64 foreigner_buy_possible_quantity = 60;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getForeignerBuyPossibleQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 60, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setForeignerBuyPossibleQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 60, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.BoardEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.BoardEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.BoardEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.BoardEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    eventId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    tscProdGrpId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    boardIdOriginal: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.BoardEvent}
 */
proto.proto.mdds.v1.BoardEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.BoardEvent;
  return proto.proto.mdds.v1.BoardEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.BoardEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.BoardEvent}
 */
proto.proto.mdds.v1.BoardEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {!proto.proto.mdds.v1.BoardEventID} */ (reader.readEnum());
      msg.setEventId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 5:
      var value = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 6:
      var value = /** @type {!proto.proto.mdds.v1.TscProdGrpId} */ (reader.readEnum());
      msg.setTscProdGrpId(value);
      break;
    case 7:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardIdOriginal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.BoardEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.BoardEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.BoardEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.BoardEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEventId();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTscProdGrpId();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getBoardIdOriginal();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BoardID board_id = 2;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getBoardId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional BoardEventID event_id = 3;
 * @return {!proto.proto.mdds.v1.BoardEventID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getEventId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardEventID} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardEventID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setEventId = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp sending_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
*/
proto.proto.mdds.v1.BoardEvent.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.BoardEvent.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional TradingSessionID trading_session_id = 5;
 * @return {!proto.proto.mdds.v1.TradingSessionID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getTradingSessionId = function() {
  return /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TradingSessionID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.clearTradingSessionId = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.BoardEvent.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TscProdGrpId tsc_prod_grp_id = 6;
 * @return {!proto.proto.mdds.v1.TscProdGrpId}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getTscProdGrpId = function() {
  return /** @type {!proto.proto.mdds.v1.TscProdGrpId} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TscProdGrpId} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setTscProdGrpId = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional BoardID board_id_original = 7;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getBoardIdOriginal = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setBoardIdOriginal = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.SymbolBoardEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.SymbolBoardEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SymbolBoardEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    boardEvent: (f = msg.getBoardEvent()) && proto.proto.mdds.v1.BoardEvent.toObject(includeInstance, f),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent}
 */
proto.proto.mdds.v1.SymbolBoardEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.SymbolBoardEvent;
  return proto.proto.mdds.v1.SymbolBoardEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.SymbolBoardEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent}
 */
proto.proto.mdds.v1.SymbolBoardEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.mdds.v1.BoardEvent;
      reader.readMessage(value,proto.proto.mdds.v1.BoardEvent.deserializeBinaryFromReader);
      msg.setBoardEvent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.SymbolBoardEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.SymbolBoardEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SymbolBoardEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoardEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.mdds.v1.BoardEvent.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional BoardEvent board_event = 1;
 * @return {?proto.proto.mdds.v1.BoardEvent}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.getBoardEvent = function() {
  return /** @type{?proto.proto.mdds.v1.BoardEvent} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.BoardEvent, 1));
};


/**
 * @param {?proto.proto.mdds.v1.BoardEvent|undefined} value
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent} returns this
*/
proto.proto.mdds.v1.SymbolBoardEvent.prototype.setBoardEvent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent} returns this
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.clearBoardEvent = function() {
  return this.setBoardEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.hasBoardEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent} returns this
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.MarketIndex.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.MarketIndex.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.MarketIndex} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MarketIndex.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    marketIndexClass: jspb.Message.getFieldWithDefault(msg, 3, 0),
    indexTypeCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    transactTime: (f = msg.getTransactTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    valueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    totalVolumeTraded: jspb.Message.getFieldWithDefault(msg, 8, 0),
    grossTradeAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    contauctAccTrdVol: jspb.Message.getFieldWithDefault(msg, 10, 0),
    contauctAccTrdVal: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    blkTrdAccTrdVol: jspb.Message.getFieldWithDefault(msg, 12, 0),
    blkTrdAccTrdVal: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    fluctuationUpperLimitIssueCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    fluctuationUpIssueCount: jspb.Message.getFieldWithDefault(msg, 15, 0),
    fluctuationSteadinessIssueCount: jspb.Message.getFieldWithDefault(msg, 16, 0),
    fluctuationDownIssueCount: jspb.Message.getFieldWithDefault(msg, 17, 0),
    fluctuationLowerLimitIssueCount: jspb.Message.getFieldWithDefault(msg, 18, 0),
    fluctuationUpIssueVolume: jspb.Message.getFieldWithDefault(msg, 19, 0),
    fluctuationSteadinessIssueVolume: jspb.Message.getFieldWithDefault(msg, 20, 0),
    fluctuationDownIssueVolume: jspb.Message.getFieldWithDefault(msg, 21, 0),
    highestValueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
    lowestValueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
    changedValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
    changedRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
    priorValueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
    indexName: jspb.Message.getFieldWithDefault(msg, 27, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.MarketIndex}
 */
proto.proto.mdds.v1.MarketIndex.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.MarketIndex;
  return proto.proto.mdds.v1.MarketIndex.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.MarketIndex} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.MarketIndex}
 */
proto.proto.mdds.v1.MarketIndex.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 3:
      var value = /** @type {!proto.proto.mdds.v1.MarketIndexClass} */ (reader.readEnum());
      msg.setMarketIndexClass(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexTypeCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValueIndexes(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalVolumeTraded(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossTradeAmount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setContauctAccTrdVol(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContauctAccTrdVal(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBlkTrdAccTrdVol(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBlkTrdAccTrdVal(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationUpperLimitIssueCount(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationUpIssueCount(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationSteadinessIssueCount(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationDownIssueCount(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationLowerLimitIssueCount(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFluctuationUpIssueVolume(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFluctuationSteadinessIssueVolume(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFluctuationDownIssueVolume(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighestValueIndexes(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowestValueIndexes(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChangedValue(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChangedRatio(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriorValueIndexes(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.MarketIndex.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.MarketIndex.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.MarketIndex} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MarketIndex.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMarketIndexClass();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getIndexTypeCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getTotalVolumeTraded();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getGrossTradeAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getContauctAccTrdVol();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getContauctAccTrdVal();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getBlkTrdAccTrdVol();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getBlkTrdAccTrdVal();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getFluctuationUpperLimitIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getFluctuationUpIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getFluctuationSteadinessIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getFluctuationDownIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
  f = message.getFluctuationLowerLimitIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getFluctuationUpIssueVolume();
  if (f !== 0) {
    writer.writeUint64(
      19,
      f
    );
  }
  f = message.getFluctuationSteadinessIssueVolume();
  if (f !== 0) {
    writer.writeUint64(
      20,
      f
    );
  }
  f = message.getFluctuationDownIssueVolume();
  if (f !== 0) {
    writer.writeUint64(
      21,
      f
    );
  }
  f = message.getHighestValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getLowestValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getChangedValue();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getChangedRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getPriorValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getIndexName();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
};


/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional TradingSessionID trading_session_id = 2;
 * @return {!proto.proto.mdds.v1.TradingSessionID}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getTradingSessionId = function() {
  return /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TradingSessionID} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional MarketIndexClass market_index_class = 3;
 * @return {!proto.proto.mdds.v1.MarketIndexClass}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getMarketIndexClass = function() {
  return /** @type {!proto.proto.mdds.v1.MarketIndexClass} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketIndexClass} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setMarketIndexClass = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string index_type_code = 4;
 * @return {string}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getIndexTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setIndexTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string currency_code = 5;
 * @return {string}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp transact_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getTransactTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
*/
proto.proto.mdds.v1.MarketIndex.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.MarketIndex.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional double value_indexes = 7;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional uint64 total_volume_traded = 8;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getTotalVolumeTraded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double gross_trade_amount = 9;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getGrossTradeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setGrossTradeAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional uint64 contauct_acc_trd_vol = 10;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getContauctAccTrdVol = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setContauctAccTrdVol = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double contauct_acc_trd_val = 11;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getContauctAccTrdVal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setContauctAccTrdVal = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional uint64 blk_trd_acc_trd_vol = 12;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getBlkTrdAccTrdVol = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setBlkTrdAccTrdVol = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional double blk_trd_acc_trd_val = 13;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getBlkTrdAccTrdVal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setBlkTrdAccTrdVal = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional uint32 fluctuation_upper_limit_issue_count = 14;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationUpperLimitIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationUpperLimitIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional uint32 fluctuation_up_issue_count = 15;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationUpIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationUpIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional uint32 fluctuation_steadiness_issue_count = 16;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationSteadinessIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationSteadinessIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional uint32 fluctuation_down_issue_count = 17;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationDownIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationDownIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional uint32 fluctuation_lower_limit_issue_count = 18;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationLowerLimitIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationLowerLimitIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional uint64 fluctuation_up_issue_volume = 19;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationUpIssueVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationUpIssueVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional uint64 fluctuation_steadiness_issue_volume = 20;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationSteadinessIssueVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationSteadinessIssueVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional uint64 fluctuation_down_issue_volume = 21;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationDownIssueVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationDownIssueVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional double highest_value_indexes = 22;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getHighestValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setHighestValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional double lowest_value_indexes = 23;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getLowestValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setLowestValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional double changed_value = 24;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getChangedValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setChangedValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional double changed_ratio = 25;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getChangedRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setChangedRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional double prior_value_indexes = 26;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getPriorValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setPriorValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional string index_name = 27;
 * @return {string}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getIndexName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setIndexName = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.Tick.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.Tick.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.Tick} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Tick.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isin: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    matchPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    matchQtty: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    boardIdOriginal: jspb.Message.getFieldWithDefault(msg, 8, 0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    totalVolumeTraded: jspb.Message.getFieldWithDefault(msg, 10, 0),
    grossTradeAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    side: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.Tick}
 */
proto.proto.mdds.v1.Tick.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.Tick;
  return proto.proto.mdds.v1.Tick.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.Tick} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.Tick}
 */
proto.proto.mdds.v1.Tick.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchQtty(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 8:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardIdOriginal(value);
      break;
    case 9:
      var value = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalVolumeTraded(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossTradeAmount(value);
      break;
    case 12:
      var value = /** @type {!proto.proto.mdds.v1.Tick.Side} */ (reader.readEnum());
      msg.setSide(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.Tick.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.Tick.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.Tick} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Tick.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIsin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMatchPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMatchQtty();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBoardIdOriginal();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getTotalVolumeTraded();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getGrossTradeAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.mdds.v1.Tick.Side = {
  SIDE_UNSPECIFIED: 0,
  SIDE_BUY: 1,
  SIDE_SELL: 2
};

/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.Tick.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BoardID board_id = 2;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.Tick.prototype.getBoardId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string isin = 3;
 * @return {string}
 */
proto.proto.mdds.v1.Tick.prototype.getIsin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setIsin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.Tick.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double match_price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.Tick.prototype.getMatchPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setMatchPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double match_qtty = 6;
 * @return {number}
 */
proto.proto.mdds.v1.Tick.prototype.getMatchQtty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setMatchQtty = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp sending_time = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.Tick.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
*/
proto.proto.mdds.v1.Tick.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Tick.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional BoardID board_id_original = 8;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.Tick.prototype.getBoardIdOriginal = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setBoardIdOriginal = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional TradingSessionID trading_session_id = 9;
 * @return {!proto.proto.mdds.v1.TradingSessionID}
 */
proto.proto.mdds.v1.Tick.prototype.getTradingSessionId = function() {
  return /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TradingSessionID} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional uint64 total_volume_traded = 10;
 * @return {number}
 */
proto.proto.mdds.v1.Tick.prototype.getTotalVolumeTraded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double gross_trade_amount = 11;
 * @return {number}
 */
proto.proto.mdds.v1.Tick.prototype.getGrossTradeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setGrossTradeAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional Side side = 12;
 * @return {!proto.proto.mdds.v1.Tick.Side}
 */
proto.proto.mdds.v1.Tick.prototype.getSide = function() {
  return /** @type {!proto.proto.mdds.v1.Tick.Side} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.proto.mdds.v1.Tick.Side} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.mdds.v1.TopPrice.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.TopPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.TopPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.TopPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isin: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    bidList: jspb.Message.toObjectList(msg.getBidList(),
    proto.proto.mdds.v1.OrderMini.toObject, includeInstance),
    offerList: jspb.Message.toObjectList(msg.getOfferList(),
    proto.proto.mdds.v1.OrderMini.toObject, includeInstance),
    totalOfferQtty: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    totalBidQtty: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    boardIdOriginal: jspb.Message.getFieldWithDefault(msg, 10, 0),
    symbolType: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.TopPrice}
 */
proto.proto.mdds.v1.TopPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.TopPrice;
  return proto.proto.mdds.v1.TopPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.TopPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.TopPrice}
 */
proto.proto.mdds.v1.TopPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 6:
      var value = new proto.proto.mdds.v1.OrderMini;
      reader.readMessage(value,proto.proto.mdds.v1.OrderMini.deserializeBinaryFromReader);
      msg.addBid(value);
      break;
    case 7:
      var value = new proto.proto.mdds.v1.OrderMini;
      reader.readMessage(value,proto.proto.mdds.v1.OrderMini.deserializeBinaryFromReader);
      msg.addOffer(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalOfferQtty(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalBidQtty(value);
      break;
    case 10:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardIdOriginal(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.TopPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.TopPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.TopPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIsin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBidList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.proto.mdds.v1.OrderMini.serializeBinaryToWriter
    );
  }
  f = message.getOfferList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.proto.mdds.v1.OrderMini.serializeBinaryToWriter
    );
  }
  f = message.getTotalOfferQtty();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getTotalBidQtty();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getBoardIdOriginal();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getSymbolType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.TopPrice.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BoardID board_id = 2;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.TopPrice.prototype.getBoardId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string isin = 3;
 * @return {string}
 */
proto.proto.mdds.v1.TopPrice.prototype.getIsin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setIsin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.TopPrice.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp sending_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.TopPrice.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
*/
proto.proto.mdds.v1.TopPrice.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.TopPrice.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated OrderMini bid = 6;
 * @return {!Array<!proto.proto.mdds.v1.OrderMini>}
 */
proto.proto.mdds.v1.TopPrice.prototype.getBidList = function() {
  return /** @type{!Array<!proto.proto.mdds.v1.OrderMini>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.mdds.v1.OrderMini, 6));
};


/**
 * @param {!Array<!proto.proto.mdds.v1.OrderMini>} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
*/
proto.proto.mdds.v1.TopPrice.prototype.setBidList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.proto.mdds.v1.OrderMini=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.OrderMini}
 */
proto.proto.mdds.v1.TopPrice.prototype.addBid = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.proto.mdds.v1.OrderMini, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.clearBidList = function() {
  return this.setBidList([]);
};


/**
 * repeated OrderMini offer = 7;
 * @return {!Array<!proto.proto.mdds.v1.OrderMini>}
 */
proto.proto.mdds.v1.TopPrice.prototype.getOfferList = function() {
  return /** @type{!Array<!proto.proto.mdds.v1.OrderMini>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.mdds.v1.OrderMini, 7));
};


/**
 * @param {!Array<!proto.proto.mdds.v1.OrderMini>} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
*/
proto.proto.mdds.v1.TopPrice.prototype.setOfferList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.proto.mdds.v1.OrderMini=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.OrderMini}
 */
proto.proto.mdds.v1.TopPrice.prototype.addOffer = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.proto.mdds.v1.OrderMini, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.clearOfferList = function() {
  return this.setOfferList([]);
};


/**
 * optional double total_offer_qtty = 8;
 * @return {number}
 */
proto.proto.mdds.v1.TopPrice.prototype.getTotalOfferQtty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setTotalOfferQtty = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double total_bid_qtty = 9;
 * @return {number}
 */
proto.proto.mdds.v1.TopPrice.prototype.getTotalBidQtty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setTotalBidQtty = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional BoardID board_id_original = 10;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.TopPrice.prototype.getBoardIdOriginal = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setBoardIdOriginal = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string symbol_type = 11;
 * @return {string}
 */
proto.proto.mdds.v1.TopPrice.prototype.getSymbolType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setSymbolType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.OrderMini.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.OrderMini.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.OrderMini} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.OrderMini.toObject = function(includeInstance, msg) {
  var f, obj = {
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    qtty: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.OrderMini}
 */
proto.proto.mdds.v1.OrderMini.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.OrderMini;
  return proto.proto.mdds.v1.OrderMini.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.OrderMini} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.OrderMini}
 */
proto.proto.mdds.v1.OrderMini.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setQtty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.OrderMini.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.OrderMini.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.OrderMini} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.OrderMini.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getQtty();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double price = 1;
 * @return {number}
 */
proto.proto.mdds.v1.OrderMini.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.OrderMini} returns this
 */
proto.proto.mdds.v1.OrderMini.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double qtty = 2;
 * @return {number}
 */
proto.proto.mdds.v1.OrderMini.prototype.getQtty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.OrderMini} returns this
 */
proto.proto.mdds.v1.OrderMini.prototype.setQtty = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.proto.mdds.v1.MarketIndexClass = {
  MARKET_INDEX_CLASS_UNSPECIFIED: 0,
  MARKET_INDEX_CLASS_HSX: 1,
  MARKET_INDEX_CLASS_HNX: 2,
  MARKET_INDEX_CLASS_COMPOSITE: 3,
  MARKET_INDEX_CLASS_UPX: 4
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.MarketID = {
  MARKET_ID_UNSPECIFIED: 0,
  MARKET_ID_BDO: 1,
  MARKET_ID_BDX: 2,
  MARKET_ID_DVX: 3,
  MARKET_ID_HCX: 4,
  MARKET_ID_RPO: 5,
  MARKET_ID_STO: 6,
  MARKET_ID_STX: 7,
  MARKET_ID_UPX: 8
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.BoardID = {
  BOARD_ID_UNSPECIFIED: 0,
  BOARD_ID_AL: 1,
  BOARD_ID_G1: 2,
  BOARD_ID_G2: 3,
  BOARD_ID_G3: 4,
  BOARD_ID_G4: 5,
  BOARD_ID_G7: 6,
  BOARD_ID_G8: 7,
  BOARD_ID_R1: 8,
  BOARD_ID_T1: 9,
  BOARD_ID_T2: 10,
  BOARD_ID_T3: 11,
  BOARD_ID_T4: 12,
  BOARD_ID_T6: 13
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.BoardEventID = {
  BOARD_EVENT_ID_UNSPECIFIED: 0,
  BOARD_EVENT_ID_AA1: 1,
  BOARD_EVENT_ID_AB1: 2,
  BOARD_EVENT_ID_AB2: 3,
  BOARD_EVENT_ID_AC2: 4,
  BOARD_EVENT_ID_AD1: 5,
  BOARD_EVENT_ID_AD2: 6,
  BOARD_EVENT_ID_AE1: 7,
  BOARD_EVENT_ID_AE8: 8,
  BOARD_EVENT_ID_AF1: 9,
  BOARD_EVENT_ID_AF6: 10,
  BOARD_EVENT_ID_AF7: 11,
  BOARD_EVENT_ID_AF8: 12,
  BOARD_EVENT_ID_AQ3: 13,
  BOARD_EVENT_ID_AT6: 14,
  BOARD_EVENT_ID_AW8: 15,
  BOARD_EVENT_ID_AW9: 16,
  BOARD_EVENT_ID_AX1: 17,
  BOARD_EVENT_ID_BB1: 18,
  BOARD_EVENT_ID_BC1: 19,
  BOARD_EVENT_ID_BE9: 20,
  BOARD_EVENT_ID_BF9: 21,
  BOARD_EVENT_ID_CC1: 22,
  BOARD_EVENT_ID_CD1: 23,
  BOARD_EVENT_ID_CD3: 24,
  BOARD_EVENT_ID_DB2: 25,
  BOARD_EVENT_ID_DC2: 26,
  BOARD_EVENT_ID_EI1: 27,
  BOARD_EVENT_ID_EI8: 28,
  BOARD_EVENT_ID_EI9: 29,
  BOARD_EVENT_ID_GT1: 30
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.ProductGrpID = {
  PRODUCT_GRP_ID_UNSPECIFIED: 0,
  PRODUCT_GRP_ID_BDO: 1,
  PRODUCT_GRP_ID_BDX: 2,
  PRODUCT_GRP_ID_FBX: 3,
  PRODUCT_GRP_ID_FIO: 4,
  PRODUCT_GRP_ID_HCX: 5,
  PRODUCT_GRP_ID_RPO: 6,
  PRODUCT_GRP_ID_STO: 7,
  PRODUCT_GRP_ID_STX: 8,
  PRODUCT_GRP_ID_UPX: 9
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SISecurityStatus = {
  SI_SECURITY_STATUS_UNSPECIFIED: 0,
  SI_SECURITY_STATUS_HALT: 1,
  SI_SECURITY_STATUS_NO_HALT: 2
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.TradingSessionID = {
  TRADING_SESSION_ID_UNSPECIFIED: 0,
  TRADING_SESSION_ID_01: 1,
  TRADING_SESSION_ID_10: 2,
  TRADING_SESSION_ID_11: 3,
  TRADING_SESSION_ID_20: 4,
  TRADING_SESSION_ID_21: 5,
  TRADING_SESSION_ID_30: 6,
  TRADING_SESSION_ID_40: 7,
  TRADING_SESSION_ID_50: 8,
  TRADING_SESSION_ID_51: 9,
  TRADING_SESSION_ID_60: 10,
  TRADING_SESSION_ID_70: 11,
  TRADING_SESSION_ID_80: 12,
  TRADING_SESSION_ID_90: 13,
  TRADING_SESSION_ID_99: 14
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.PutOrCall = {
  PUT_OR_CALL_UNSPECIFIED: 0,
  PUT_OR_CALL_PUT: 1,
  PUT_OR_CALL_CALL: 2
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SIExerciseStyle = {
  SI_EXERCISE_STYLE_UNSPECIFIED: 0,
  SI_EXERCISE_STYLE_AMERICAN: 1,
  SI_EXERCISE_STYLE_EUROPEAN: 2,
  SI_EXERCISE_STYLE_BERMUDA_STYLE: 3,
  SI_EXERCISE_STYLE_ETC: 4
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SettleMethod = {
  SETTLE_METHOD_UNSPECIFIED: 0,
  SETTLE_METHOD_CASH: 1,
  SETTLE_METHOD_ASSET: 2,
  SETTLE_METHOD_CASH_ASSET: 3,
  SETTLE_METHOD_NONE: 4
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SymbolAdminStatusCode = {
  SYMBOL_ADMIN_STATUS_CODE_UNSPECIFIED: 0,
  SYMBOL_ADMIN_STATUS_CODE_CR: 1,
  SYMBOL_ADMIN_STATUS_CODE_CTR: 2,
  SYMBOL_ADMIN_STATUS_CODE_NRM: 3,
  SYMBOL_ADMIN_STATUS_CODE_RES: 4,
  SYMBOL_ADMIN_STATUS_CODE_WFR: 5,
  SYMBOL_ADMIN_STATUS_CODE_WID: 6,
  SYMBOL_ADMIN_STATUS_CODE_WOV: 7
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SymbolTradingMethodStatusCode = {
  SYMBOL_TRADING_METHOD_STATUS_CODE_UNSPECIFIED: 0,
  SYMBOL_TRADING_METHOD_STATUS_CODE_NRM: 1,
  SYMBOL_TRADING_METHOD_STATUS_CODE_NWE: 2,
  SYMBOL_TRADING_METHOD_STATUS_CODE_NWN: 3,
  SYMBOL_TRADING_METHOD_STATUS_CODE_SLS: 4,
  SYMBOL_TRADING_METHOD_STATUS_CODE_SNE: 5
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SymbolTradingSanctionStatusCode = {
  SYMBOL_TRADING_SANCTION_STATUS_CODE_UNSPECIFIED: 0,
  SYMBOL_TRADING_SANCTION_STATUS_CODE_NRM: 1,
  SYMBOL_TRADING_SANCTION_STATUS_CODE_SUS: 2,
  SYMBOL_TRADING_SANCTION_STATUS_CODE_DTL: 3,
  SYMBOL_TRADING_SANCTION_STATUS_CODE_TFR: 4
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.TscProdGrpId = {
  TSC_PROD_GRP_ID_UNSPECIFIED: 0,
  TSC_PROD_GRP_ID_BDO: 1,
  TSC_PROD_GRP_ID_BDX: 2,
  TSC_PROD_GRP_ID_FBX: 3,
  TSC_PROD_GRP_ID_FIO: 4,
  TSC_PROD_GRP_ID_HCX: 5,
  TSC_PROD_GRP_ID_RPO: 6,
  TSC_PROD_GRP_ID_STO: 7,
  TSC_PROD_GRP_ID_STX: 8,
  TSC_PROD_GRP_ID_UPX: 9
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SecurityGroupID = {
  SECURITY_GROUP_ID_UNSPECIFIED: 0,
  SECURITY_GROUP_ID_BS: 1,
  SECURITY_GROUP_ID_EF: 2,
  SECURITY_GROUP_ID_EW: 3,
  SECURITY_GROUP_ID_FU: 4,
  SECURITY_GROUP_ID_MF: 5,
  SECURITY_GROUP_ID_SR: 6,
  SECURITY_GROUP_ID_ST: 7,
  SECURITY_GROUP_ID_BT: 8,
  SECURITY_GROUP_ID_BG: 9,
  SECURITY_GROUP_ID_DR: 10
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SectorTypeCode = {
  SECTOR_TYPE_CODE_UNSPECIFIED: 0,
  SECTOR_TYPE_CODE_PREMIER: 1,
  SECTOR_TYPE_CODE_STANDARD: 2,
  SECTOR_TYPE_CODE_ALTERNATIVE: 3
};

goog.object.extend(exports, proto.proto.mdds.v1);
